import { z } from "zod";

import {
  heroSectionSchema,
  newsletterSectionSchema,
  pageSeoSchema,
} from "@/content/schemas";
import { siteConfig } from "@/content/site";
import { validateContent } from "@/content/validateContent";

const newsletterPageSchema = z.object({
  seo: pageSeoSchema,
  hero: heroSectionSchema,
  newsletterSection: newsletterSectionSchema,
});

export const newsletterPageContent = validateContent("newsletterPage", newsletterPageSchema, {
  seo: {
    title: "Newsletter | Tech Savvy Starts Here",
    description: "Subscribe to the Tech Savvy Starts Here newsletter and browse published issues on Beehiiv.",
    canonicalPath: "/newsletter",
    socialImage: "/social-card.svg",
  },
  hero: {
    eyebrow: "Newsletter",
    title: "Practical Tech Insights",
    accent: "in Your Inbox",
    description:
      "Subscribe for practical lessons, beginner friendly insights, and real world ways to use AI and digital tools.",
    primaryCta: {
      label: "Subscribe",
      href: siteConfig.beehiivSubscribeUrl,
      external: true,
    },
    secondaryCta: {
      label: "Browse Past Issues",
      href: siteConfig.beehiivPublicationUrl,
      external: true,
    },
  },
  newsletterSection: {
    title: "Subscribe and read the newsletter",
    description:
      "Subscribe here or visit the newsletter homepage to read past issues and explore practical lessons on AI and digital tools.",
    embed: {
      title: "Beehiiv embedded form",
      embedHtml: siteConfig.beehiivEmbedHtml,
      placeholderLabel: "Beehiiv embed placeholder for the dedicated newsletter page",
      aspectRatio: "form",
    },
    primaryCta: {
      label: "Subscribe Now",
      href: siteConfig.beehiivSubscribeUrl,
      external: true,
    },
    secondaryCta: {
      label: "Read the Newsletter",
      href: siteConfig.beehiivPublicationUrl,
      external: true,
    },
  },
});
